@import 'styles/mixins';
@import 'styles/variables';

.actionForm {
  display: flex;
  flex-direction: row;
}

.userIdInput {
  @include inter-regular;
  font-size: 12px !important;

  border: 1px solid var(--neutral-10);
  border-radius: 4px;
  margin-right: 12px;
  width: 114px !important;
  padding: 0 10px;
  text-align: left !important;

  &:focus {
    border-color: var(--focus-50);
  }

  &::placeholder {
    @include inter-regular;
    font-size: 12px !important;
  }
}

.error {
  color: var(--negative-50);
}
